import styles from "./MainContent.module.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import instagram from "../../images/instagram.svg";
import share from "../../images/share.svg";
import addFavWhite from "../../images/add-fav-white.svg";
import removeFavRed from "../../images/remove-fav-red.svg";
import watch from "../../images/watch.svg";
import verified from "../../images/verified.svg";
import bid from "../../images/bid.svg";
import {
  showBannerModal,
  updateUserFavorites,
  startBidding,
} from "../../store/actions";
import db from "../../firebase";
import { updateDoc, doc, Timestamp } from "firebase/firestore";
import { useState, useEffect } from "react";
import { checkCookie } from "../Common";

export default function MainContent() {
  const dispatch = useDispatch();
  const celebData = useSelector((state) => state.celebData);
  const loggedUser = useSelector((state) => state.loggedUser);
  const activeCelebData = useSelector((state) => state.activeCelebData);
  const activeCelebId = useSelector((state) => state.activeCelebId);
  const activeImage = useSelector((state) => state.activeImage);
  const dataFilter = celebData.filter((item) => item.id === activeCelebId)[0];
  const [liveTime, setLiveTime] = useState(0);

  function bannerModalFn(event) {
    if (!event.target.classList.contains("banner-exclude")) {
      dispatch(showBannerModal());
    }
  }

  const addFavPic = () => {
    let temp = loggedUser.favorites;
    temp.push(activeCelebData[activeImage].public_id);
    dispatch(updateUserFavorites(temp));
    updateDoc(doc(db, "user_data", loggedUser.uid), {
      favorites: temp,
    });
  };

  const removeFavPic = () => {
    const temp = loggedUser.favorites.filter(
      (item) => item !== activeCelebData[activeImage].public_id
    );
    dispatch(updateUserFavorites(temp));
    updateDoc(doc(db, "user_data", loggedUser.uid), {
      favorites: temp,
    });
  };

  const bidFn = () => {
    if (!checkCookie("active_user")) {
      alert("Login first!");
      return;
    }
    dispatch(
      startBidding({
        userId: loggedUser.uid,
        imageId: activeCelebData[activeImage].id,
        celebId: activeCelebId,
      })
    );
  };

  return (
    <div
      className={styles.mainContent}
      onClick={(event) => bannerModalFn(event)}
    >
      <div className={styles.mainContentInner}>
        <div className={styles.celebDetail}>
          <div>
            <h2 className={`${styles.heading} d-inline-block banner-exclude`}>
              {dataFilter.name}
              {dataFilter.verified ? (
                <img
                  src={verified}
                  className={`${styles.verifiedBadge} banner-exclude`}
                  alt="Verified Icon"
                />
              ) : null}
            </h2>
          </div>
          <p className={styles.para}>
            <span className="banner-exclude">@{dataFilter.handle}</span>
            <span className="ms-5 banner-exclude">
              {dataFilter.followers}M followers
            </span>
          </p>
          <p>
            <a
              href={`https://www.instagram.com/${dataFilter.handle}`}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={instagram}
                alt="Instagram Icon"
                className={`${styles.socialImg} banner-exclude`}
              />
            </a>
            <Link to="/">
              <img
                src={share}
                alt="Share Icon"
                className={`${styles.socialImg} ms-2 banner-exclude`}
              />
            </Link>
            {loggedUser.uid ? (
              loggedUser.favorites.find(
                (ele) => ele === activeCelebData[activeImage].public_id
              ) ? (
                <img
                  src={removeFavRed}
                  alt="Remove Favorite Icon"
                  className={`${styles.socialImg} ms-2 cursor-pointer banner-exclude`}
                  onClick={() => removeFavPic()}
                />
              ) : (
                <img
                  src={addFavWhite}
                  alt="Add Favorite Icon"
                  className={`${styles.socialImg} ms-2 cursor-pointer banner-exclude`}
                  onClick={() => addFavPic()}
                />
              )
            ) : (
              <img
                src={addFavWhite}
                alt="Add Favorite Icon"
                className={`${styles.socialImg} ms-2 cursor-pointer banner-exclude`}
                onClick={() => alert("Login to add favorites")}
              />
            )}
          </p>
        </div>
        <div className={styles.celebImageDetail}>
          <div>
            <p className={`${styles.para2} d-inline-block banner-exclude`}>
              Highest Bid
            </p>
          </div>
          <div>
            <h2 className={`${styles.heading2} banner-exclude d-inline-block`}>
              ${activeCelebData[activeImage].highestBid}
            </h2>
          </div>
          <div>
            <p className={`${styles.para2} d-inline-block banner-exclude`}>
              <img
                src={watch}
                alt="Time Icon"
                className={`${styles.timeIcon} banner-exclude`}
              />
              {activeCelebData[activeImage].startTime &&
              activeCelebData[activeImage].startTime !== 0 &&
              activeCelebData[activeImage].startTime.toDate() < new Date() ? (
                <RemainTime
                  time={activeCelebData[activeImage].timeLeft.seconds}
                  liveTime={liveTime}
                  setLiveTime={setLiveTime}
                />
              ) : (
                "0.0.0.0 Left"
              )}
            </p>
          </div>

          {activeCelebData[activeImage].startTime &&
            activeCelebData[activeImage].startTime !== 0 &&
            activeCelebData[activeImage].startTime.toDate() < new Date() &&
            liveTime > 0 && (
              <div>
                <button
                  className={`${styles.button} banner-exclude`}
                  onClick={bidFn}
                >
                  BUY NOW
                  <img
                    src={bid}
                    alt="Buy Icon"
                    className={`${styles.bidNowIcon} banner-exclude`}
                  />
                </button>
              </div>
            )}
        </div>
      </div>
      <div className={`${styles.moreCelebImage} banner-exclude`}>
        More from {dataFilter.name}...
      </div>
    </div>
  );
}

const RemainTime = ({ time, liveTime, setLiveTime }) => {
  function timeFormat(seconds) {
    var secondss = parseInt(seconds);
    var days = Math.floor(secondss / (3600 * 24));
    secondss -= days * 3600 * 24;
    var hrs = Math.floor(secondss / 3600);
    secondss -= hrs * 3600;
    var mnts = Math.floor(secondss / 60);
    secondss -= mnts * 60;
    return days + ":" + hrs + ":" + mnts + ":" + secondss;
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setLiveTime(
        time - Timestamp.fromDate(new Date()).seconds > 0
          ? time - Timestamp.fromDate(new Date()).seconds
          : 0
      );
    }, 1000);
    return () => clearInterval(interval);
  }, [time]);

  return timeFormat(liveTime) + " Left";
};
